<template>
  <el-dialog
    v-on="$listeners"
    v-bind="{
      'close-on-click-modal': false,
      'append-to-body': true,
      ...$attrs
    }"
  >
    <template #title>
      <slot name="title" />
    </template>
    <div v-if="rendered">
      <slot />
    </div>
    <template #footer>
      <slot name="footer" />
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'Dialog',

  inheritAttrs: true,

  data() {
    return {
      rendered: false
    }
  },

  watch: {
    '$attrs.visible'(val) {
      if (val) {
        this.rendered = true
      } else {
        this.$nextTick(() => {
          this.rendered = false
        })
      }
    }
  }
}
</script>
